import { render, staticRenderFns } from "./QuotationTableForLazyLoadingWithResize.vue?vue&type=template&id=21bcf56e&scoped=true"
import script from "./QuotationTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"
export * from "./QuotationTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bcf56e",
  null
  
)

export default component.exports